import { render, staticRenderFns } from "./AppMenu.vue?vue&type=template&id=20019127&scoped=true"
import script from "./AppMenu.vue?vue&type=script&lang=ts"
export * from "./AppMenu.vue?vue&type=script&lang=ts"
import style0 from "./AppMenu.vue?vue&type=style&index=0&id=20019127&prod&scoped=true&lang=scss"
import style1 from "./AppMenu.vue?vue&type=style&index=1&id=20019127&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20019127",
  null
  
)

export default component.exports